import { createResource } from 'react-resource-router';

import { fg } from '@atlaskit/platform-feature-flags';

import { getCompressionRatio } from '../endpoint';
import { type CompressionRatioResponse } from '../types';

const emptyCompressionBanner = {
	compressionRatio: 0,
	uniqueGroupCount: 0,
	rollingWindow: 0,
};

export const compressionRatioResource = createResource<CompressionRatioResponse | null>({
	type: 'compressionRatioResource',
	getKey: () => 'compressionRatioResource',
	getData: async () => {
		// When unified-view-revamp is enabled, return null instead of making the API call
		if (fg('unified-view-revamp')) {
			return null;
		}

		try {
			const response = await getCompressionRatio();
			return response;
		} catch (e) {
			return emptyCompressionBanner;
		}
	},
	maxAge: 5 * 60 * 1000, // 5 minutes
	isBrowserOnly: true,
});
